import qs from 'query-string';

export const getSearchParams = () =>
  typeof window !== 'undefined'
    ? qs.parse(window.location.href.split('?')[1])
    : {};
